module.exports = __webpack_public_path__ + "img/avatar5.1e8c1c0d.svg";